module.exports = __webpack_public_path__ + "img/Priority_icon.cf94ffe6.png";